import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('/account/group/', 'manege');

// tbl.add(new Xtc('id', 'code'))
tbl.add(new Xtc('title', 'title'))
tbl.add(new Xtc('users', 'users').renderSlot('lawyer_user'))
tbl.add(new Xtc('actions', 'actions').renderSlot('act'))

export default tbl;

